import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { DynamicTranslation, UpdatedTranslations } from "../types";

export const updateDynamicTranslations = async (
  updatedTranslations: UpdatedTranslations,
) => {
  const collectionRef = collection(db, "dynamicTranslations");

  const updatePromises = Object.entries(updatedTranslations).map(
    async ([id, newTranslations]) => {
      const docRef = doc(collectionRef, id);

      // Fetch the current document to retain existing translations
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const currentData = docSnap.data() as DynamicTranslation;
        const updatedData = { ...currentData.translations, ...newTranslations };

        // Update the document with the new translations
        await updateDoc(docRef, { translations: updatedData });
      } else {
        console.error(`Document with ID ${id} does not exist`);
      }
    },
  );

  await Promise.all(updatePromises);
};
